import { storageData } from "services/Services"

const EstimatedMileageList = () => {
    let options = []
    try {
        const dropdownOptions = JSON.parse(storageData.getItem('DropdownOptions'))
        const mileageOptions = dropdownOptions.rows.filter(row => row.QuestionID === "103")

        if (mileageOptions.length > 0) {
            options = [
                <option key="default" disabled value="">Select from the following...</option>,
                ...mileageOptions.map(answer => (
                    <option key={answer.AnswerID} value={answer.AnswerText}>{answer.AnswerText}</option>
                ))
            ]
        }
    } catch (error) {
        console.error(error)
        options = [<option key="default" value="" disabled>Select from the following...</option>]
    }

    return <>{options}</>
}

export default EstimatedMileageList